<template>
    <fieldset :class="isOpen ? 'open' : ''">
        <header @click="toggle">{{header}}</header>

        <section v-show="isOpen">
            <slot></slot>
        </section>
    </fieldset>
</template>

<script>
    export default {
        data() {
            return {
                isOpen: this.defaultState === "open"
            };
        },
        props: {
            header: String,
            defaultState: {
                default: "closed"
            }
        },
        methods: {
            toggle() {
                this.isOpen = !this.isOpen;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../sass/variables";

    fieldset {
        margin-bottom: 30px;

        &.open {
            .header {
                border-radius: 0;
            }
        }

        & > header {
            border-radius: 4px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            height: 50px;
            cursor: pointer;
            display: flex;
            align-items: center;
            padding: 0 10px;
            background: $page-background;
            color: $header-text-color;
            font-size: 14px;
            font-weight: 600;
            width: 100%;
            user-select: none;
        }

        & > section {
            padding: 20px;
            width: 100%;
            background: #fff;
            border:1px solid $page-background;
        }

        .row {
            margin-bottom: 20px;

            &:last-of-type {
                margin-bottom: 0;
            }
        }
    }
</style>
